import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { getPaymentStatus } from '../lib/api';

export function PaymentSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const sessionId = params.get('session_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    getPaymentStatus(sessionId)
      .then(res => setStatus(res.data?.payment_status === 'paid' ? 'paid' : 'pending'))
      .catch(() => setStatus('pending'));
  }, [sessionId]);

  return (
    <div className="payment-result-page" data-testid="payment-success">
      <motion.div className="payment-result-card" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }}>
        {status === 'loading' ? (
          <Loader2 size={48} className="animate-spin" style={{ color: '#4A5D3A' }} />
        ) : (
          <>
            <CheckCircle size={56} style={{ color: '#4A5D3A' }} strokeWidth={1} />
            <h1 className="payment-result-title">Thank You!</h1>
            <p className="payment-result-text">Your order has been placed successfully. We'll prepare your blend with care.</p>
            <button onClick={() => navigate('/')} className="payment-result-btn" data-testid="back-home-btn">Back to Home</button>
            <button onClick={() => navigate('/track-order')} className="payment-result-btn-secondary" data-testid="track-order-btn">Track Your Order</button>
          </>
        )}
      </motion.div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="payment-result-page" data-testid="payment-cancel">
      <motion.div className="payment-result-card" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }}>
        <XCircle size={56} style={{ color: '#B4483E' }} strokeWidth={1} />
        <h1 className="payment-result-title">Payment Cancelled</h1>
        <p className="payment-result-text">No worries — your cart is waiting for you. Come back anytime.</p>
        <button onClick={() => navigate('/')} className="payment-result-btn" data-testid="back-home-btn">Back to Shopping</button>
      </motion.div>
    </div>
  );
}
